import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {Grid, Typography} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';
import EmpionLogo from '../EmpionLogoAnimation/EmpionLogo';

import {AppConfig} from '../../lib/AppConfig';

interface Props {
  isOutOfBounds?: boolean;
}

export const ErrorMessage = ({isOutOfBounds}: Props) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const onClick = () => {
    navigate(AppConfig.DASHBOARD_PATH);
  };
  return (
    <Grid container justifyContent='center' alignItems='center' flexDirection='column' padding='16px'>
      <EmpionLogo withAnimation />
      <Typography paddingY='16px' textAlign='center' variant='h1'>
        {isOutOfBounds ? t('error.outOfBounds') : t('error.title')}
      </Typography>
      {!isOutOfBounds ? (
        <Typography paddingBottom='16px' textAlign='center' variant='body1'>
          {t('error.subtitle')}
        </Typography>
      ) : null}
      <Grid>
        <EmpionButton variant='text' onClick={onClick}>
          {t('error.button')}
        </EmpionButton>
      </Grid>
    </Grid>
  );
};
